import { render, staticRenderFns } from "./coverage-map.vue?vue&type=template&id=1f277c1c&scoped=true&"
import script from "./coverage-map.vue?vue&type=script&lang=js&"
export * from "./coverage-map.vue?vue&type=script&lang=js&"
import style0 from "./coverage-map.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./coverage-map.vue?vue&type=style&index=1&id=1f277c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f277c1c",
  null
  
)

/* custom blocks */
import block0 from "./coverage-map.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports